import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VMenu,
    {
      attrs: {
        "offset-y": "",
        "close-on-content-click": true,
        "min-width": "100%",
        "max-width": "100%",
        "content-class": "info-mobile-menu__content",
        transition: "slide-y-transition",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "div",
                _vm._g(
                  _vm._b(
                    {
                      staticClass:
                        "info-mobile-menu__activator d-flex align-center justify-center w-100 pa-4 position-relative cursor-pointer",
                    },
                    "div",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _setup.isOpen
                    ? _c(
                        VIcon,
                        {
                          staticClass:
                            "info-mobile-menu__icon info-mobile-menu__icon_left primary--text",
                          attrs: { size: "20" },
                        },
                        [_vm._v("\n        ui-icon-check\n      ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticClass: "text-body-1 ma-0",
                      class: _setup.isOpen ? "primary--text" : "text--text",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.t(_vm.title, _setup.options)) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  !_setup.isOpen
                    ? _c(
                        VIcon,
                        {
                          staticClass:
                            "info-mobile-menu__icon info-mobile-menu__icon_right text-secondary--text",
                          attrs: { size: "20" },
                        },
                        [_vm._v("\n        ui-icon-arrow-down\n      ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _setup.isOpen,
        callback: function ($$v) {
          _setup.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _vm._v(" "),
      _c(
        VList,
        { staticClass: "py-0" },
        [
          _vm._l(_setup.visibleRoutes, function (route) {
            return _c(
              VListItem,
              {
                key: route.path,
                staticClass: "justify-center",
                attrs: { href: route.path },
              },
              [
                _c(
                  VListItemTitle,
                  { staticClass: "text-body-1 text--text text-center" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_setup.t(route.label, _setup.options)) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            VListItem,
            {
              staticClass: "justify-center",
              on: {
                click: function ($event) {
                  _setup.isOpen = false
                },
              },
            },
            [
              _c(
                VListItemTitle,
                { staticClass: "text-body-1 text-secondary--text text-center" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_setup.t("Свернуть", _setup.options)) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                VIcon,
                {
                  staticClass: "text-secondary--text ml-2",
                  attrs: { size: "20" },
                },
                [_vm._v("\n        ui-icon-arrow-up\n      ")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }